import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';
import { EditorContext } from '../../index';
import { Container } from '../core/container';
import { Frame } from 'scenejs';

import styles from './form.module.scss';
import { useWidgetSelector } from 'components/Editor/hooks/useEditorSession';

const FormStepWidget = ({ className, style, widgetProps, widgetRef, children, ...rest }) => {
  const ref = widgetRef;
  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const [state, setState] = useState({
    formStyles: {}
  });

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const breakpoint = useSelector(state => _.get(state, `${editor}.present.breakpoint`));
  const properties = _.get(widgetProps, 'properties', {});
  const active = _.get(rest, 'activeStep', false);
  
  const parentWidget = useWidgetSelector(editor, widgetProps.parent);
  
  const width = _.get(parentWidget, `properties.${breakpoint}.layout.width`) || 'auto';
  const height = _.get(parentWidget, `properties.${breakpoint}.layout.height`)  || 'auto';

  const widgetStyles = {
    ...style,
    width: width,
    height: height,
    marginLeft: 0
  };

  return (
    <Container widgetProps={widgetProps} widgetRef={widgetRef}>
      <div id={id}
        ref={ref}
        className={cx(className, styles.formStep, {
          [styles.active]: active
        })}
        style={widgetStyles}
        data-widget-id={id}
        data-container={active}
        data-widget-type={type}
        data-selectable={false}
      >
        {children}
      </div>
    </Container>
  );
};

FormStepWidget.moveableConfig = (editorSession, widget) => {
  return {
    draggable: false,
    resizable: false,
    rotatable: false,
    selectable: false,
    cloneable: false,
    deletable: false,
    renderDirections: ['e', 'w', 's'],
    onReparent: (widget, parent) => {
      return false
    },
    onResize: (widget, layout, breakpoint) => {
      const frame = new Frame(layout);
      frame.set('transform', 'translate', '0px, 0px');
      frame.remove('width');
      frame.remove('height');

      return frame.get();
    }
  }
}

export { FormStepWidget };